module.exports = __webpack_public_path__ + "img/home-solid.89dfadd8.svg";